
import React from 'react';
import { Container, Box, Grid } from "@mui/material";
import PrimaryHeading from '../../Utilities/PrimaryHeading';
import BaseTypography from '../../Utilities/BaseTypography';

export default function Introduction() {
  return (
    <Container maxWidth={false}
      sx={{
        backgroundImage: `url('/images/introductionBg.svg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '500px',
        pt: 4,
        position: 'relative',
        "&::after": {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '15px',
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          background: 'linear-gradient(270.29deg, #3766F3 0.24%, #43B0D7 99.74%)',
          opacity: '25%',
          zIndex: 1,
        },
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12} md={7} sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <PrimaryHeading
              sx={{
                textAlign: { xs: 'center', md: 'left' },
                pb: 1,
              }}
            >Introduction</PrimaryHeading>
            <BaseTypography sx={{
              py: 3,
              letterSpacing: '0.4px',
              textAlign: { xs: 'center', md: 'left' }
            }}>
              Welcome to NC pro by GB International, where innovation meets precision in non-conformity management. Our software is specifically designed for engineering industries to record, analyse and eliminate quality issues, enhance operational efficiency, and ultimately boost profitability.
            </BaseTypography>
            <BaseTypography sx={{
              textAlign: { xs: 'center', md: 'left' },
              pb: 2,
              letterSpacing: '0.4px',
            }}>
              With NC pro, you can streamline your quality control processes,
              prevent recurring issues, and ensure your end-products meet the
              highest standards.
            </BaseTypography>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                display: "flex",
                justifyContent: {
                  md: 'flex-end',
                  xs: 'center'
                },
                alignItems: "center",
                height: "100%",
              }}
            >
              <img
                src="/images/mac-login-screen.svg"
                alt="NC Pro"
                style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Container>
  )
}